<template>
	<h1 v-if="title" class="page-title" :id="id">
		{{ title }}
	</h1>
</template>

<script setup>
const props = defineProps({
	fields: { type: Object, required: true },
	rendering: { type: Object, required: false },
});

const title = computed(() => props.fields?.title?.value);
const id = computed(() => props.fields?.id?.value);
</script>

<style lang="scss">
.page-title {
	scroll-margin-top: calc(var(--header-height, 54px) + var(--spacing-2, 16px));
	padding: var(--spacing-2, 16px);
	margin-top: var(--spacing-8, 64px);
	color: var(--color-white, #fff);
	font-size: var(--text-2xl, 32px);
	font-family: var(--primary-font, sans-serif);
	margin-bottom: 0;
	font-weight: 900;
	line-height: 110%;
	text-transform: uppercase;
}
</style>
